import OrganisationSettings from "./organisationSettings"
import { Consumer, Provider, OrganisationSettingsContext } from "./organisationSettings.context"

export { Consumer, Provider, OrganisationSettingsContext }
export default OrganisationSettings
